// extracted by mini-css-extract-plugin
export var bullet = "_sg-q";
export var bulletText = "_sg-p";
export var bullets = "_sg-k";
export var callout = "_sg-g";
export var calloutBody = "_sg-i";
export var calloutLabel = "_sg-h";
export var checkIcon = "_sg-m";
export var checkList = "_sg-j";
export var checkSvg = "_sg-n";
export var checkText = "_sg-o";
export var fieldCard = "_sg-1";
export var fieldDescription = "_sg-5";
export var fieldHeader = "_sg-3";
export var fieldTitle = "_sg-4";
export var finalNote = "_sg-s";
export var flow = "_sg-x";
export var flowArrow = "_sg-v";
export var flowStep = "_sg-u";
export var helperText = "_sg-r";
export var inlineTitle = "_sg-t";
export var listItem = "_sg-l";
export var noteBody = "_sg-8";
export var noteBodyText = "_sg-9";
export var noteCard = "_sg-2";
export var noteIcon = "_sg-6";
export var noteTitle = "_sg-7";
export var productChoices = "_sg-w";
export var radioDot = "_sg-d";
export var radioDotSelected = "_sg-e";
export var radioDotSvg = "_sg-f";
export var selectableCard = "_sg-b";
export var selectableCardSelected = "_sg-c";
export var strongText = "_sg-a";
export var subHeading = "_sg-0";